'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FlexRegion = undefined;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _FlexRegionStyled = require('./styles/FlexRegionStyled');

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var propTypes = {
  /** Container will occupy all available space */
  spread: _propTypes2.default.bool,

  /** Set content flow direction */
  layoutDirection: _propTypes2.default.oneOf(['horizontal', 'vertical'])
};
var defaultProps = {
  spread: false,
  layoutDirection: 'vertical'
};

var FlexRegion = exports.FlexRegion = function FlexRegion(props) {
  return _react2.default.createElement(_FlexRegionStyled.FlexRegionStyled, {
    spread: props.spread,
    layoutDirection: props.layoutDirection
  }, props.children);
};

FlexRegion.propTypes = propTypes;
FlexRegion.defaultProps = defaultProps;
FlexRegion.displayName = 'FlexRegion';